<template>
    <div>
        <Preference></Preference>
        <hr>
        <UserInfo></UserInfo>
    </div>
</template>

<script>
import UserInfo from './UserInfo';
import Preference from './Preference';
export default {
    components: {
        UserInfo,
        Preference,
    },
}
</script>

<style scoped>

</style>